import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { FRAGMENT_CONTENT_VALIDATION } from 'src/graphql/schema';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationUpdateVariationContentValidationArgs,
  BackendVariation,
} from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateVariationContentValidation($id: ID!) {
    updateVariationContentValidation(id: $id) {
      id
      contentSafety {
        ...ContentValidation
      }
    }
  }
  ${FRAGMENT_CONTENT_VALIDATION}
`;

type Variables = BackendMutationUpdateVariationContentValidationArgs;
type Result = Pick<BackendVariation, 'id' | 'contentSafety'>;

export const updateVariationContentValidation = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
